import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { TicketStates as TicketStates, TicketTypes } from ".";
import TicketsAPI from "../../lib/API/TicketsAPI";

const Ticket = () => {

    const { id } = useParams();
    const [ticket, setTicket] = useState();
    const [lastUpdate, setLastUpdate] = useState();
    const [message, setMessage] = useState();
    const [solveBtnDisabled, setSolveBtnDisabled] = useState(false);

    useEffect(() => {
        TicketsAPI.GetTicket(id)
            .then(({ data }) => {
                setTicket(data)
                if(data.messages && data.messages.length){
                    setLastUpdate(data.messages[data.messages.length-1].date);
                }
            })
            .catch(() => alert("An error occured"));
    }, [id])

    const submit = () => {
        TicketsAPI.Reply(id, message)
            .then(() => {
                setMessage('');
                setTicket({ ...ticket, messages: ticket.messages.concat({ message, date: new Date() }) });
            })
            .catch(() => alert('An error occured'));
    }

    const onMessageInput = ({ target }) => {
        setMessage(target.value)
    }

    const markAsSolved = () => {
        setSolveBtnDisabled(true);
        TicketsAPI.MarkAsSolved(id)
            .then(() => {
                setTicket({...ticket, state : 'SOLVED'});
            })
            .catch(() => alert('An error occured'))
            .finally(() => setSolveBtnDisabled(false))
    }

    if (!ticket) return <></>

    return (
        <>
            <div className="products-search">
                <h3>Ticket</h3>
            </div>
            <div className="container py-5">
                <div className="row">
                    <div className="col-md-4 col-sm-12 p-lg-5 p-md-3" style={{ borderRight : "2px solid black" }}>
                        <div className="text-center">
                            <TicketBadge state={ticket.state}/>
                        </div>
                        <h6>Ticket Title :</h6>
                        <h4 className="open-font-condensed mb-4">{ticket.title}</h4>
                        <h6>Description :</h6>
                        <h4 className="open-font-condensed mb-4"><small>{ticket.content}</small></h4>
                        <h6>Ticket Type :</h6>
                        <h5 className="open-font-condensed mb-4">{TicketTypes[ticket.type]}</h5>
                        {ticket.order && (
                            <>
                                <h6>Order </h6>
                                <h5 className="open-font-condensed">
                                    <Link to={"/orders/" + ticket.order.id}><small>{ticket.order.label}</small></Link>
                                </h5>
                            </>
                        )}
                        {ticket.messages.length != 0 && (
                            <>
                                <h6>Last update</h6>
                                <h5 className="open-font-condensed"><small>{moment(lastUpdate).format("DD MMM yyyy hh:mm")}</small></h5>
                            </>
                        )}
                    </div>
                    <div className="col-md-8 col-sm-12 p-lg-5 p-md-3">

                        <h3>Messages : </h3>
                        {ticket.messages.length == 0 && (
                            <p className="text-center">No messages rceived yet, we will contact you soon.</p>
                        )}
                        {ticket.messages.map((message, i) => (
                            <>
                                <div key={i}>
                                    <div className="open-font-condensed">{message.sentByAdmin ? 'Giftswap staff' : "You"} :</div>
                                    <div className="text-muted">{moment(message.date).format('DD MMM yyyy hh:mm')} : </div>
                                    <p>{message.message}</p>
                                </div>
                                <hr></hr>
                            </>
                        ))}
                        <div className="row mb-3">
                            <div className="col">
                                <label className="control-label open-font-condensed h3">Reply : </label>
                                <textarea value={message} className="form-control swap-input" rows={5} onChange={onMessageInput}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-center mb-3">
                                <button className="btn btn-black btn-outline" onClick={submit}>Submit</button>
                            </div>
                        </div>
                        {ticket.state != 'SOLVED' && ticket.state != 'CLOSED' && (
                            <div className="row">
                                <div className="col text-center mb-3">
                                    <button className="btn btn-black btn-outline" onClick={markAsSolved} disabled={solveBtnDisabled}>Mark as solved</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </>
    )
}

const TicketBadge = ({ state }) => {
    let className = "ticket-badge ";
    switch(TicketStates[state]){
        case TicketStates.WAITING:
            className += "badge-warning";
            break;
        case TicketStates.ADMIN_ANSWERED:
            className += "badge-outline";
            break;
        case TicketStates.USER_ANSWERED:
            className += "badge-grey";
            break;
        case TicketStates.SOLVED:
            className += "badge-success";
            break;
        default:
            className += "badge-black";
    }

    return (
        <div className={className}>{TicketStates[state]}</div>
    )
}

export { Ticket };